import { Card, Col, Container, Row } from 'react-bootstrap';
import {
    FaChartBar,
    FaClipboardList,
    FaCogs,
    FaFileInvoiceDollar,
    FaLock,
    FaMapMarkerAlt,
    FaMoneyCheckAlt,
    FaUsers
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const modules = [
    { key: 'crm', title: 'CRM', icon: <FaUsers />, description: 'Customer profiles and support' },
    { key: 'billing', title: 'Billing', icon: <FaFileInvoiceDollar />, description: 'Automated bill generation' },
    { key: 'collection', title: 'Collection', icon: <FaMoneyCheckAlt />, description: 'Track and manage payments' },
    { key: 'field', title: 'Field & Tracking', icon: <FaMapMarkerAlt />, description: 'Field task scheduling' },
    { key: 'workorders', title: 'Work Orders', icon: <FaClipboardList />, description: 'Manage service tasks' },
    { key: 'reporting', title: 'Reporting', icon: <FaChartBar />, description: 'Generate insights and reports' },
    { key: 'admin', title: 'Administrator', icon: <FaCogs />, description: 'System configuration and users' },
    { key: 'security', title: 'Security', icon: <FaLock />, description: 'Roles and permissions' },
];

const Modules = () => {
    const navigate = useNavigate();

    const handleClick = (moduleKey) => {
        navigate(`/${moduleKey}`);
    };


    return (
        <Container className="py-5">
            <h2 className="mb-4 text-center">UMS Modules</h2>
            <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                {modules.map((mod) => (
                    <Col key={mod.key}>
                        <Card className="text-center shadow-sm h-100" onClick={() => handleClick(mod.key)} style={{ cursor: 'pointer' }}>
                            <Card.Body>
                                <div className="mb-3" style={{ fontSize: '2rem', color: '#0d6efd' }}>
                                    {mod.icon}
                                </div>
                                <Card.Title>{mod.title}</Card.Title>
                                <Card.Text>{mod.description}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default Modules;
